import React from 'react';

import CommonImage from '@components/CommonImage';

const DEFAULT_IMAGE = '/images/default_product.svg';

const FolderListCard = ({ folder, onSelect, isActive }) => {
	const renderImage = (index) => {
		const imageUrl = folder?.documents && folder?.documents[index];
		return <CommonImage src={imageUrl || DEFAULT_IMAGE} alt="product" isStatic={!imageUrl} />;
	};

	return (
		<div
			className={`single-moodbord d-flex align-items-center align-self-center mb-12 cursor-pointer ${
				isActive ? 'active' : ''
			}`}
			onClick={() => onSelect(folder)}
		>
			<div className="left-img">
				<div className="product-img-container pt-0">
					<div className="prev-img">{renderImage(0)}</div>
					<div className="prev-img-thumb">
						<div className="single-first">{renderImage(1)}</div>
						<div className="single-second">{renderImage(2)}</div>
					</div>
				</div>
			</div>
			<div className="product-content ml-12">
				<p className="regular-14 weight-500 gray_dark_01 pb-1">{folder?.name}</p>
				<p className="regular-14 gray_dark_02">{folder?.brandResponse?.name}</p>
			</div>
		</div>
	);
};

export default FolderListCard;
